import { useState, useMemo } from 'react'

export default function bullet({ thisBullet }) {
  const [showConccretly_, setShowConcretly] = useState(false)
  const hasConcretly = useMemo(() => thisBullet.concretly.length > 0, [thisBullet])
  const showConccretly = useMemo(() => hasConcretly && showConccretly_, [hasConcretly, showConccretly_])

  return (
    <div className="h-full" onMouseLeave={() => setShowConcretly(false)} id={thisBullet.id}>
      <div className="relative z-10 text-center font-serif text-9xl text-yellow">{thisBullet.id}</div>
      <div
        className={`${
          showConccretly ? 'bg-orange' : 'bg-backgroundLight'
        } relative z-20 -mt-10 h-[calc(100%-5.5rem)] w-full border-2 border-orange  p-10 text-black `}>
        <div className={`${showConccretly ? 'hidden' : 'block'} pb-6`}>
          <h2 className="mx-10 text-center text-lg font-medium uppercase">{thisBullet.name}</h2>
          <div className="mt-4 space-y-4 text-justify">{thisBullet.description}</div>

          {hasConcretly && (
            <div className="absolute bottom-6 left-0 w-full text-center">
              <button onClick={() => setShowConcretly(true)} className="font-extralight uppercase text-orange">
                En savoir plus
              </button>
            </div>
          )}
        </div>

        <div className={`${showConccretly ? 'block' : 'hidden'}  h-full  w-full text-white  `}>
          <div className="text-lg font-medium uppercase">{thisBullet.concretlyTitle || 'Concrètement'}</div>
          <ul className="mt-4 list-outside list-disc space-y-2">
            {thisBullet.concretly.map((thisConcret, index) => (
              <li key={index} className="leading-tight">
                {thisConcret}
              </li>
            ))}
          </ul>
        </div>

        {hasConcretly && (
          <button
            onClick={() => setShowConcretly((prev) => !prev)}
            className="absolute -top-16 left-6 inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-orange text-orange focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 34 34"
              className={`${
                showConccretly ? 'rotate-45 duration-200 ease-out' : 'rotate-0 duration-200 ease-in'
              } h-8 w-8 transform  transition-transform`}
              stroke="currentColor">
              <path strokeWidth={2} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}
